import { NgModule } from '@angular/core';
import { PaymentService } from './services/payment.service';

@NgModule({
  providers: [PaymentService]
})
export class DomainPaymentModule {}